<script lang="ts">
  import { Link } from "@inertiajs/svelte";

  let {
    user,
    currentPath,
    onSearchClick,
  }: {
    user: { id: string; name: string; email: string; avatarUrl?: string };
    currentPath: string;
    onSearchClick: () => void;
  } = $props();

  function isActive(path: string): boolean {
    return currentPath.startsWith(path);
  }
</script>

<div class="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 md:hidden" style="padding-bottom: env(safe-area-inset-bottom);">
  <nav class="pill-glass flex items-center gap-1 px-2 py-2">
    <!-- Trips -->
    <Link
      href="/trips"
      class="relative flex flex-col items-center gap-0.5 px-4 py-2 rounded-2xl transition-all duration-200 cursor-pointer"
      style="color: {isActive('/trips') ? 'var(--accent)' : 'var(--text-muted)'};"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
          d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span class="text-[10px] font-medium">여행</span>
      {#if isActive('/trips')}
        <span class="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full" style="background: var(--accent);"></span>
      {/if}
    </Link>

    <!-- Search -->
    <button
      onclick={onSearchClick}
      class="relative flex flex-col items-center gap-0.5 px-4 py-2 rounded-2xl transition-all duration-200 cursor-pointer"
      style="color: var(--text-muted);"
      aria-label="검색"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <span class="text-[10px] font-medium">검색</span>
    </button>

    <!-- New Trip CTA -->
    <Link
      href="/trips?new=true"
      class="relative flex flex-col items-center gap-0.5 px-4 py-2 rounded-2xl transition-all duration-200 cursor-pointer"
      style="color: var(--accent);"
    >
      <div class="w-6 h-6 flex items-center justify-center rounded-full" style="background: var(--accent-dim);">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
        </svg>
      </div>
      <span class="text-[10px] font-medium">새 여행</span>
    </Link>

    <!-- Profile -->
    <Link
      href={`/users/${user.id}`}
      class="relative flex flex-col items-center gap-0.5 px-4 py-2 rounded-2xl transition-all duration-200 cursor-pointer"
      style="color: {isActive(`/users/${user.id}`) ? 'var(--accent)' : 'var(--text-muted)'};"
    >
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
      <span class="text-[10px] font-medium">프로필</span>
      {#if isActive(`/users/${user.id}`)}
        <span class="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full" style="background: var(--accent);"></span>
      {/if}
    </Link>
  </nav>
</div>
